export default __webpack_public_path__ + "static/media/mathbuddies.b78c5c80.png";